import "./restaurant.css";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import { TbReportAnalytics } from "react-icons/tb";
import { RiDeleteBinLine } from "react-icons/ri";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdClear } from 'react-icons/md';
import { IoEyeOutline } from "react-icons/io5";

import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import ButtonCom from "../../components/button/button";
import CustomPagination from "../../components/CustomPagination";
import TableSkeleton from "../../components/table/TableSkeleton.js";
import AssignEmployee from "../../components/AssignEmployee";
import Widgets from "../../components/Widgets";

import {
  fetchBranchData,
  initBranchState,
} from "../../redux/slices/branchSlice";

import {
  fetchDepartmentData,
  initDepartState,
} from "../../redux/slices/departmentSlice.js";

import {
  commonGetData,
  commonGetDataOne,
  commonSaveData,
  initCommonState,
} from "../../redux/slices/commonSlice";
import {
  getOutletAssignedStaffListPath,
  assignOutLetEmployeePath,
  getOutletListPath,
  createOutletModelPath,
  updateOutletModelPath,
  deleteOutletModelPath,
  assignOutLetEmployeeAllPath,
} from "../../services/config";
import { useDispatch, useSelector } from "react-redux";
import { HasPermission } from "../../services/hasPermission.js";

const Index = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const branchStore = useSelector((state) => state.branch);
  const departmentStore = useSelector((state) => state.department);
  const commonStore = useSelector((state) => state.common);

  const [outletList, setOutletList] = useState([]);
  const [filteredOutletList, setFilteredOutletList] = useState([]);

  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [outletId, setOutletId] = useState("");
  const [isEdit, setIsEdit] = useState("");
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);

  const [selectIs, setSelectIs] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];
  const isSelectAll =
    selectedUsers.length === employeeList.length && employeeList.length > 0;

  const [outletData, setOutletData] = useState({
    userId: user.user_id,
    staffId: "",
    outletId: "",
    outletName: "",
    frequencyType: "",
    frequencyRepeat: "",
  });
  const [gridApi, setGridApi] = useState(null);

  const [state, setState] = useState({
    branchId: "",
    departmentId: "",
  });

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getOutletList = useCallback(() => {
    const path = getOutletListPath + user.user_id;
    dispatch(commonGetDataOne(path));
  }, []);

  useEffect(() => {
    getOutletList();
  }, []);

  // const getEmployeeList = useCallback((id) => {
  //   const path = getOutletAssignedStaffListPath(id, user.user_id);
  //   dispatch(commonGetData(path));
  // }, []);

  useEffect(() => {
    const path = getOutletAssignedStaffListPath(outletId, user.user_id, state.branchId, state.departmentId);
    dispatch(commonGetData(path));
  }, [outletId, user.user_id, state.branchId, state.departmentId])

  const handleModalClose1 = () => {
    setShow1(false);
    setSelectedUsers([]);
    setSelectedUsersList([]);
    setSearchQuery("")
    setState((pre) => ({
      ...pre,
      branchId: "",
      departmentId: "",
    }))
  };

  // const handleShow1 = () => setShow1(true);
  const [outletName, setOutletName] = useState("");

  const handleAssignId = (data) => {
    setOutletId(data.id);
    setOutletName(data.outletName);
    // getEmployeeList(data.id);
    setTimeout(() => {
      setShow1(true);
    }, 500);
  };

  const selectUser = (event, userId, user) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) => {
      const updatedList = isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId);
      return updatedList;
    });

    setSelectedUsersList((prevSelected) =>
      isChecked
        ? [...prevSelected, user]
        : prevSelected.filter((u) => u.staffId !== user.staffId)
    );
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = employeeList.map((row) => row.staffId);
      setSelectedUsers(allUserIds);
      const allUserList = employeeList.map((row) => row);
      setSelectedUsersList(allUserList);
    } else {
      setSelectedUsers([]);
      setSelectedUsersList([]);
    }
  };

  const searchEmployees = (val, dataList) => {
    setSearchQuery(val);
    const filteredEmployees = dataList.filter(
      (v) =>
        v.fullName.toLowerCase().includes(val.toLowerCase()) ||
        v.employeeId.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filteredEmployees);
    setFilterEmployeeList(dataList)
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: assignOutLetEmployeePath,
      data: {
        userId: user.user_id,
        staffId: selectedUsers.toString(),
        outletId: outletId,
      },
    };
    dispatch(commonSaveData(data));
  };

  const editData = (data) => {
    setOutletData((pre) => ({
      ...pre,
      userId: user.user_id,
      staffId: "1",
      outletId: data.id,
      outletName: data.outletName,
      frequencyType: data.frequencyType,
      frequencyRepeat: data.frequencyRepeat,
    }));
    setIsEdit(true);
    setOpen(true);
  };

  const [delId, setDelId] = useState("");

  const deleteData = (id) => {
    setDelId(id);
    setShow(true);
  };

  const handleDeleteSubmit = () => {
    let d = {
      path: deleteOutletModelPath,
      data: {
        userId: user?.user_id,
        outletId: delId,
      },
    };
    dispatch(commonSaveData(d));
    setShow(false);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "SNo",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 60,
        pinned: "left",
      },
      {
        headerName: "Module Name",
        field: "outletName",
        flex: 1,
        pinned: "left",
        cellRenderer: (row) => {
          return (
            // <Link
            //   to={`/outlet-assigned-employee?outletId=${row.data.id}&userId=${user.user_id}`}
            //   style={{ textDecoration: "none" }} <HiArrowLongRight />
            // >
            <>{row.data.outletName} </>
            // </Link>
          );
        },
      },

      {
        headerName: "Frequency",
        flex: 1,
        cellRenderer: (row) => {
          return <span>{row.data.frequencyType}</span>;
        },
        //
      },

      {
        headerName: "Actions",
        cellRenderer: (row) => {
          return (
            <div>
              {HasPermission("Audit Modules", "create") && (
                <PiUserCheck
                  style={{
                    cursor: "pointer",
                    fontSize: 25,
                    marginRight: "10px",
                  }}
                  className="assign-icon"
                  onClick={() => {
                    handleAssignId(row.data);
                  }}
                />
              )}
              {HasPermission("Audit Modules", "view") && (
                <Link to={`/questionnaire?outletId=${row.data.id}`}>
                  <IoEyeOutline
                    style={{
                      cursor: "pointer",
                      fontSize: 25,
                      marginRight: "10px",
                    }}
                    className="eye-icon"
                  />
                </Link>
              )}

              {HasPermission("Audit Modules", "edit") && (
                <PiPencilSimpleLineBold
                  onClick={() => editData(row.data)}
                  style={{
                    cursor: "pointer",
                    fontSize: 24,
                    marginRight: "10px",
                  }}
                  className="edit-icon"
                />
              )}
              {HasPermission("Audit Modules", "delete") && (
                <RiDeleteBinLine className="delete-icon"
                  onClick={() => deleteData(row.data.id)}
                  style={{
                    cursor: "pointer",
                    fontSize: 25,
                    color: "red",
                    marginRight: "10px",
                  }}
                />
              )}
              {HasPermission("Audit Modules", "approve") == false &&
                HasPermission("Audit Modules", "view") == false &&
                HasPermission("Audit Modules", "edit") == false &&
                HasPermission("Audit Modules", "delete") == false &&
                "-"}
              {/* <RiDownload2Fill
                style={{
                  cursor: "pointer",
                  fontSize: 25,
                  color: "#000",
                  marginRight: "10px",
                }}
              /> */}
            </div>
          );
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "200px",
      },
    ],
    []
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOutletData((pre) => ({
      ...pre,
      userId: user.user_id,
      staffId: "",
      outletId: "",
      outletName: "",
      frequencyType: "",
      frequencyRepeat: "",
    }));
    setIsEdit(false);
  };

  const handleChange = ({ target: { name, value } }) => {
    setOutletData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    const data = {
      path: isEdit ? updateOutletModelPath : createOutletModelPath,
      data: outletData,
    };

    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      dispatch(commonSaveData(data));
    }
  };

  const [showOutletModal, setShowOutletModal] = useState(false);
  const [selectedOutlet, setSelectedOutlet] = useState([]);

  const isSelectAllOutlet =
    selectedOutlet.length === outletList.length && outletList.length > 0;

  const handleAssignOutletAll = () => {
    setShowOutletModal(true);
  };

  const selectOutlet = (event, outletId) => {
    const isChecked = event.target.checked;
    setSelectedOutlet((prevSelected) => {
      const updatedList = isChecked
        ? [...prevSelected, outletId]
        : prevSelected.filter((id) => id !== outletId);
      return updatedList;
    });
  };

  const SelectAllOutlet = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = filteredOutletList.map((row) => row.id);
      setSelectedOutlet(allUserIds);
    } else {
      setSelectedOutlet([]);
    }
  };

  const searchOutlet = (val) => {
    setSearchQuery(val);
    const filteredOutlet = outletList.filter((v) =>
      v.full_name.toLowerCase().includes(val.toLowerCase())
    );
    setOutletList(filteredOutlet);
  };

  const handleAssignOutletSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: assignOutLetEmployeeAllPath,
      data: {
        userId: user.user_id,
        outletId: selectedOutlet.toString(),
      },
    };
    dispatch(commonSaveData(data));
  };

  useEffect(() => {
    if (commonStore.commonGetSuccess || commonStore.commonGetError) {
      if (commonStore.commonGetSuccess && commonStore.commonGetData) {
        if (searchQuery != "") {
          searchEmployees(searchQuery, commonStore.commonGetData)
        } else {
          setEmployeeList(commonStore.commonGetData);
          setFilterEmployeeList(commonStore.commonGetData);

          if (commonStore.commonGetData.length > 0) {
            const initiallySelected = commonStore.commonGetData
              ?.filter((row) => row.assignedStatus === "1")
              .map((row) => row.staffId);

            setSelectedUsers(initiallySelected);

            const initiallySelectedUsers = commonStore.commonGetData
              .filter((row) => row.assignedStatus === "1") // Check API ka "selected: true"
              .map((row) => row);
            setSelectedUsersList(initiallySelectedUsers);

          }
        }

        dispatch(initCommonState());
      }
      if (commonStore.commonGetError) {
        setEmployeeList([]);
        setFilterEmployeeList([]);
        setSelectedUsers([])
        setSelectedUsersList([])
      }
    }

    if (commonStore.commonGetOneSuccess || commonStore.commonGetOneError) {
      if (commonStore.commonGetOneSuccess) {

        if (modelName != "") {
          searchModel(modelName, commonStore.commonGetOneData)
        } else {
          setOutletList(commonStore.commonGetOneData);
          setFilteredOutletList(commonStore.commonGetOneData);
          dispatch(fetchBranchData());
          dispatch(fetchDepartmentData(user.user_id));
        }

        dispatch(initCommonState());
      }
      if (commonStore.commonGetOneError) {
        console.log(commonStore.commonGetOneMessage);
        dispatch(initCommonState());
      }
    }

    if (commonStore.commonSuccess || commonStore.commonError) {
      getOutletList();

      commonStore.commonSuccess
        ? toast.success(commonStore.commonMessage)
        : toast.error(commonStore.commonMessage);

      setOutletData((pre) => ({
        ...pre,
        userId: user.user_id,
        staffId: "",
        outletId: "",
        outletName: "",
        frequencyType: "",
        frequencyRepeat: "",
      }));
      setIsEdit(false);
      setDelId("");
      setOutletId("");
      handleClose();
      handleModalClose1();
      setShowOutletModal(false);
      dispatch(initCommonState());
    }

    if (departmentStore.depGetSuccess) {
      setDepartmentList(departmentStore.depGetData);
      dispatch(initDepartState());
      console.log(departmentStore.depGetData);
    }

    if (branchStore.brnGetSuccess) {
      setBranchList(branchStore.brnGetData);
      dispatch(initBranchState());
    }
  }, [dispatch, commonStore, departmentStore, branchStore]);

  const preSubmit = () => {
    let elem = document.querySelector("#preSubmit");
    if (elem) {
      elem.click();
    }
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setState((preState) => ({
      ...preState,
      [name]: value,
    }));
  };

  const [modelName, setModelName] = useState("");
  const [branchId, setBranchId] = useState("");
  const [frequencyId, setFrequencyId] = useState("");
  const [date, setDate] = useState("");

  const searchModel = (value, dataList) => {
    setModelName(value);
    const filteredEmployees = dataList.filter(
      (v) =>
        v.outletName.toLowerCase().includes(value.toLowerCase())
    );
    setOutletList(filteredEmployees);
    setFilteredOutletList(dataList)
  };

  const filterByFrequency = (branchId) => {
    setFrequencyId(branchId);
  };

  const filterByDate = (date) => {
    setDate(date);
  };

  const filterByBranch = (branchId) => {
    setBranchId(branchId);
  };

  const date_1 = new Date();
  const year_1 = date_1.getFullYear();
  const month_1 = String(date_1.getMonth() + 1).padStart(2, "0");
  const clearFilter = () => {
    setModelName("")
    setBranchId("")
    setFrequencyId("")
    setDate(`${year_1}-${month_1}`)
  }

  return (
    <div style={{ position: "fixed", width: "calc(100%)", height: "100%" }}>
      <div className="">


        <Widgets
          icon={<p className="color-white">Manage Modules</p>}
          button={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: "10px",
              }}
            >
              {/* <ButtonCom
                type={"button"}
                class_name={"p_btn"}
                text={"Assign All Employee Modules"}
                ext
                url_or_onclick={() => setShowOutletModal(true)}
                icon={<MdOutlineAssignmentTurnedIn />}
                width={""}
              /> */}

              <ButtonCom
                type={"link"}
                class_name={"p_btn universal-btn"}
                text={"Report"}
                url_or_onclick={"/audit/report"}
                icon={<TbReportAnalytics style={{ position: "relative", top: "-2px" }} />}
                width={""}
              />
              {HasPermission("Audit Modules", "create") && (
                <ButtonCom
                  type={"button"}
                  class_name={"universal-btn border-radius-8px"}
                  text={"Create Modules"}
                  url_or_onclick={handleClickOpen}
                  icon={<AddIcon style={{ position: "relative", top: "-2px" }} />}
                  width={""}
                />
              )}
            </div>
          }
          body={
            <>
              <div className="d-flex justify-content-start align-items-center gap-2 mt-3 mb-1">
                <Form.Control
                  placeholder="Search by model name"
                  name="modelName"
                  value={modelName}
                  onChange={(e) => searchModel(e.target.value, filteredOutletList)}
                  className="universal-input"
                  style={{ width: "300px" }}
                />
                <Form.Select
                  name="frequencyId"
                  value={frequencyId}
                  onChange={(e) => filterByFrequency(e.target.value)}
                  className="universal-input"
                  style={{ width: "200px" }}
                >
                  <option>Filter By Frequency</option>
                </Form.Select>

                <Form.Control
                  type="date"
                  name="date"
                  value={date}
                  onChange={(e) => filterByDate(e.target.value)}
                  className="universal-input"
                  style={{ width: "200px", lineHeight: "38px" }}
                />

                <Form.Select
                  name="branchId"
                  value={branchId}
                  onChange={(e) => filterByBranch(e.target.value)}
                  className="universal-input"
                  style={{ width: "200px" }}
                >
                  <option value={""} style={{ color: "red" }}>Filter By Branch</option>
                  {
                    branchList.map((row) => {
                      return <option value={row.branchId} key={row.branchId}>{row.branch_name}</option>
                    })
                  }
                </Form.Select>
                <Form.Group>
                  {
                    (
                      modelName ||
                      (date && date != `${year_1}-${month_1}`) ||
                      frequencyId ||
                      branchId) && <button type="button" className="clear" onClick={clearFilter}>
                      <MdClear /> Clear
                    </button>
                  }
                </Form.Group>

              </div>
              <div
                className="ag-theme-quartz custom-grid"
                style={{
                  height: "calc(100vh - 270px )",
                  width: "100%",
                  padding: "10px 0px",
                }}
              >
                {commonStore.commonGetOneLoading ? (
                  <TableSkeleton />
                ) : (
                  <AgGridReact
                    rowData={Array.isArray(outletList) ? outletList : []}
                    columnDefs={columns}
                    omLayout="autoHeight"
                    pagination={true}
                    paginationPageSize={paginationPageSize}
                    onGridReady={onGridReady}
                  />
                )}
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination px-4">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">
              {isEdit ? "Update Module" : "Add New Module"}
            </span>
          </div>
          <button
            className="universal-btn border-radius-8px"
            onClick={preSubmit}
            style={{ minWidth: "100px", height: "30px", lineHeight: "10px" }}
          >
            {isEdit ? "Update" : "Add"}
          </button>
        </DialogTitle>

        <div style={{ overflow: "auto" }}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <DialogContent style={{ height: "auto" }}>
              <Row>
                <Col sm="12">
                  <Form.Group className="mb-2">
                    <Form.Label className="color-white">
                      Module Name <span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="outletName"
                      value={outletData.outletName}
                      placeholder="Enter Module Name"
                      onChange={handleChange}
                      required
                      className="universal-input-one"
                    />

                    <Form.Control.Feedback type={"invalid"}>
                      Please provide valid Module name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <Form.Group className="mb-2">
                    <Form.Label className="color-white">
                      Frequency Type <span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Select
                      name="frequencyType"
                      value={outletData.frequencyType}
                      onChange={handleChange}
                      required
                      className=" universal-input-one"
                    >
                      <option value={""}>Select Frequency Type</option>
                      <option value={"Daily"}>Daily</option>
                      <option value={"Weekly"}>Weekly</option>
                      <option value={"Monthly"}>Monthly</option>
                      <option value={"Yearly"}>Yearly</option>
                    </Form.Select>
                    <Form.Control.Feedback type={"invalid"}>
                      Please provide valid shift name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              {/* <Row className="mt-3">
                <Form.Label>Frequency Repeat </Form.Label>
                <Col
                  sm={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <Form.Group>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="frequencyRepeat"
                      onChange={handleChange}
                      value="1"
                      checked={
                        outletData.frequencyRepeat == "1" ? "checked" : null
                      }
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Check
                      type="radio"
                      label="No"
                      name="frequencyRepeat"
                      onChange={handleChange}
                      value="0"
                      checked={
                        outletData.frequencyRepeat == "0" ? "checked" : null
                      }
                    />
                  </Form.Group>
                </Col>
              </Row> */}

              <Button
                variant="contained"
                color="info"
                type="submit"
                style={{
                  width: "100px",
                  height: "30px",
                  borderRadius: "7px",
                  display: "none",
                }}
                className="universal-btn"
                id="preSubmit"
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </DialogContent>
          </Form>
        </div>
      </Dialog>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        className="universal-bg-color"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Module</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={() => setShow(false)}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <Modal
        show={show1}
        onHide={handleModalClose1}
        backdrop="static"
        className="custom-modal"
      >
        <Modal.Header closeButton className="custom-modal-body">
          <Modal.Title
            style={{
              display: "flex",
              flexDirection: "column",
              // alignItems: "center",
              gap: "10px",
            }}
            className="custom-modal-body"
          >
            <h4 className="color-white">Assign Employees</h4>
            <span className="color-white"> Module Name - {outletName}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ display: "flex", flexDirection: "column" }}
          className="custom-modal-body"
        >
          <input
            className="search-employee universal-input-one"
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value)}
          />
          <table className="custom-modal-body">
            <thead>
              <tr>
                <th className="universal-input-one">
                  <input
                    type="checkbox"
                    checked={isSelectAll}
                    onChange={SelectAll}
                    id="sel-all"
                    className="colored-checkbox universal-input-one"
                  />
                  &nbsp; &nbsp;
                  <label
                    style={{ cursor: "pointer", color: "#fff" }}
                    htmlFor="sel-all"
                  >
                    Select All
                  </label>
                </th>
                <th className="universal-input-one">Employee Name</th>
              </tr>
            </thead>
            <tbody>
              {employeeList.length > 0 ? (
                employeeList.map((row) => (
                  <tr key={row.staffId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(row.staffId)}
                        onChange={(e) => selectUser(e, row.staffId)}
                        id={"shift" + row.staffId}
                        className="colored-checkbox"
                      />
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor={"shift" + row.staffId}
                      >
                        {row.fullName}
                      </label>
                      <span style={{ fontSize: "12px", color: "gray" }}>
                        {row.employee_id}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No employees found</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#566573",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose1}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#5dade2", color: "#fff" }}
            onClick={handleAssignShiftSubmit}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal> */}

      <Modal
        show={showOutletModal}
        onHide={() => setShowOutletModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Employee to this Module</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
          <input
            className="search-employee"
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => searchOutlet(e.target.value)}
          />
          <table className="audit-tbl">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={isSelectAllOutlet}
                    onChange={SelectAllOutlet}
                    id="sel-all"
                    className="colored-checkbox"
                  />
                  &nbsp; &nbsp;
                  <label style={{ cursor: "pointer" }} htmlFor="sel-all">
                    Select All
                  </label>
                </th>
                <th>Employee Name</th>
              </tr>
            </thead>
            <tbody>
              {filteredOutletList.length > 0 ? (
                filteredOutletList.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedOutlet.includes(row.id)}
                        onChange={(e) => selectOutlet(e, row.id)}
                        id={"outlet" + row.id}
                        className="colored-checkbox"
                      />
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor={"outlet" + row.id}
                      >
                        {row.outletName}
                      </label>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No Module found</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#566573",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={() => setShowOutletModal(false)}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#5dade2", color: "#fff" }}
            onClick={handleAssignOutletSubmit}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <AssignEmployee
        isOpen={show1}
        closeOpenDialog={handleModalClose1}
        submitData={handleAssignShiftSubmit}
        isSelectAll={isSelectAll}
        SelectAll={SelectAll}
        selectedUsersList={selectedUsersList}
        employeeList={employeeList}
        selectedUsers={selectedUsers}
        selectUser={selectUser}
        branchList={branchList}
        departmentList={departmentList}
        state={state}
        handleInputChange={handleInputChange}
        getData={""}
        searchQuery={searchQuery}
        searchEmployees={searchEmployees}
        outletName={outletName}
        dataList={filterEmployeeList}
      />

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default Index;
